import { OrganizationTableItem } from 'types/organizations_table'

export function calculateWeightedTotal(dealOrDeals: OrganizationTableItem | OrganizationTableItem[]): number {
  const deals = Array.isArray(dealOrDeals) ? dealOrDeals : [dealOrDeals]

  const weightedSum = deals.reduce((sum, deal) => {
    // total can be in deal.totals.total (your NCO code) or legacy deal.total
    const rawTotal = deal?.totals?.total ?? deal?.total ?? 0
    const dealTotal = rawTotal != null ? parseFloat(String(rawTotal).replace(/[$,]/g, '')) : 0

    // probability might be deal.probability (string/number), default 50
    const rawProb = deal?.probability ?? 50
    const prob = parseFloat(String(rawProb))
    const factor = Number.isFinite(prob) ? prob / 100 : 0.5

    return sum + dealTotal * factor
  }, 0)

  return Math.round(weightedSum)
}
